import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import PressableScale from './PressableScaleButton';
import Icon from '../Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';
import type { IconNames } from '@ant-design/react-native/lib/icon';

export interface OptionCardProps {
  title: string;
  isSelected: boolean;
  onPress: () => void;
  disabled?: boolean;
  icon?: IconNames;
  className?: string;
}

export const OptionCard: React.FC<OptionCardProps> = ({
  title,
  isSelected,
  onPress,
  disabled = false,
  icon,
  className = ''
}) => {
  return (
    <PressableScale
      onPress={onPress}
      disabled={disabled}
      frameClassName={`border rounded-2xl ${className} ${disabled
          ? 'border-gray-200 bg-gray-100'
          : isSelected
            ? 'border-primary-500 bg-primary-50'
            : 'border-gray-300 bg-white'
        }`}
      contentClassName="px-6 py-7"
    >
      {({ pressed }) => (
        <View className="flex-row items-center justify-between" style={optionCardStyles.content}>
          <View className="flex-row items-center flex-1">
            {icon && (
              <Icon
                name={icon}
                size={20}
                color={
                  disabled
                    ? colorPalette.gray[400]
                    : isSelected || pressed
                      ? colorPalette.primary[700]
                      : colorPalette.gray[500]
                }
                className="mr-3"
              />
            )}
            <Text
              className={`flex-1 text-base font-medium ${disabled
                  ? 'text-gray-400'
                  : isSelected || pressed
                    ? 'text-primary-700'
                    : 'text-gray-900'
                }`}
            >
              {title}
            </Text>
          </View>
          {isSelected && !disabled && (
            <Icon
              name="check"
              size={20}
              color={colorPalette.primary[500]}
            />
          )}
        </View>
      )}
    </PressableScale>
  );
};

const optionCardStyles = {

  content: {
    paddingVertical: 20,
    minHeight: 80,
  }
};

export default OptionCard;
